exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".demo-banner-block {\n\n    display: none\n}\n\n@media (min-width: 1280px) {\n\n    .demo-banner-block {\n\n        display: block\n    }\n}\n\n.demo-banner-hidden {\n\n    display: none\n}\n", ""]);

